/**
 * Shared tool emoji mapping for consistent display across the application.
 * Each tool has a unique, distinctive emoji that represents its function.
 */

const TOOL_EMOJI_MAP = {
  // Creation & Generation
  "3d_model_generation": "🗿",
  // Moai - iconic sculptural form
  image_generation: "🌅",
  // Sunrise over mountains - new imagery emerging
  image_adaptation: "🪄",
  // Magic wand - transformation
  video_creation: "🎬",
  // Clapper board

  // Search & Retrieval
  internet_search: "🌐",
  deep_internet_search: "🐳",
  // Telescope - searching far and wide
  images_retrieval: "🖼️",
  // Framed picture
  rag: "📖",
  // Ancient scroll - knowledge retrieval
  conversation_retrieval: "🗨️",
  // Left speech bubble
  deep_rag: "📚",
  folder_access: "📁",
  // Folder icon
  // Analysis & Thinking
  deep_thinking: "🧠",
  // Ocean wave - going deep
  reasoning: "🤔",
  // Direct hit - targeted logic
  analyze: "🔬",
  // Test tube - scientific analysis
  introspection: "🪞",
  // Mirror - self-reflection
  doc_by_doc_analysis: "📖",
  // Clipboard - systematic review

  // Code & Data
  code_interpreter: "💻",
  // Snake - Python/coding
  charting: "📊",
  // Bar chart

  // Communication
  email: "💌",
  // Postbox - outgoing mail
  sms: "📲",
  // Love letter - personal messaging
  messaging: "📲",
  // Mobile with arrow - instant messaging
  ask_user_question: "💬",
  // Microphone - asking/interviewing
  greeting: "💬",
  // Saluting face

  // Workspace & Organization
  canvas: "🎨",
  // Artist palette - creative workspace
  canvas_generation: "🎨",
  // Artist palette - canvas generation
  browser: "🖥",
  // Spider - web crawler
  tagging: "🏷️",
  // Label tag
  scheduling: "📅",
  // Calendar
  task_delegation: "🎪",
  // Circus tent - orchestrating many acts
  parallel_tools: "⚡",
  // Lightning - parallel execution

  // Memory & Storage
  long_term_memory: "🗄️" // DNA - encoded memory
};

/**
 * Get the emoji for a given tool ID.
 * @param {string} toolId - The tool identifier
 * @returns {string} The emoji for the tool, or a default lightning bolt
 */
const getToolEmoji = toolId => {
  return TOOL_EMOJI_MAP[toolId] || "⚡";
};
var AppToolEmojis = {
  TOOL_EMOJI_MAP,
  getToolEmoji
};

export { AppToolEmojis as default };
